module.exports = __webpack_public_path__ + "0bdc484877c30f8b4d44289853aebb6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_27_teaser_image.jpg
// module id = 546
// module chunks = 0